<script setup lang="ts">
import DarkModeSwitcher from "../../components/DarkModeSwitcher";
import Button from "../../base-components/Button";
import FormRegistro from "./components/FormRegistro.vue";
import { computed, ref } from "vue";
import { userUserStore } from "../../stores/user";
import { getAuth, signOut } from "firebase/auth";
import router from "../../router";
import SignInFromRegistro from "./components/SignInFromRegistro.vue";

const ambiente = import.meta.env.VITE_ENV_NOMBRE;
const userStore = userUserStore();
const isLoggedIn = computed(() => userStore.userLoggedIn != null);
const registroListo = ref(false);

const signOutHandler = () => {
  const auth = getAuth();
  signOut(auth)
    .then(() => {
      userStore.signOut();
      router.push("/registro");
    })
    .catch(error => {
      // An error happened.
    });
};

const handlerRegistroListo = () => {
  registroListo.value = true;
};

const irProduccion = () => {
  window.location.href = "https://acceso.atiendo.cloud";
};
</script>

<template>
  <div
    :class="[
      '-m-3 sm:-mx-8 p-3 sm:px-8 relative h-screen lg:overflow-hidden bg-primary xl:bg-white dark:bg-darkmode-800 xl:dark:bg-darkmode-600',
      'before:hidden before:xl:block before:content-[\'\'] before:w-[57%] before:-mt-[28%] before:-mb-[16%] before:-ml-[13%] before:absolute before:inset-y-0 before:left-0 before:transform before:rotate-[-4.5deg] before:bg-primary/20 before:rounded-[100%] before:dark:bg-darkmode-400',
      'after:hidden after:xl:block after:content-[\'\'] after:w-[57%] after:-mt-[20%] after:-mb-[13%] after:-ml-[13%] after:absolute after:inset-y-0 after:left-0 after:transform after:rotate-[-4.5deg] after:bg-primary after:rounded-[100%] after:dark:bg-darkmode-700'
    ]"
  >
    <!-- <DarkModeSwitcher /> -->
    <div class="z-10">
      <div class="block grid-cols-2 gap-4 xl:grid">
        <!-- BEGIN: Registro Info -->
        <div class="flex-col hidden min-h-screen xl:flex pl-12">
          <div class="my-auto">
            <img
              alt="Logo Atiendo"
              class="w-1/2 -mt-16 -intro-x"
              src="/src/assets/images/atiendoLogo.png"
            />
            <div
              style="font-family: Helvetica Neue"
              class="mt-10 text-4xl font-medium leading-tight text-white -intro-x"
            >
              <br />

              <template v-if="ambiente != 'Produccion'">
                <p class="mt-5 text-danger p-3 bg-white">Ambiente DEMO</p>
              </template>
            </div>
          </div>
        </div>

        <!-- END: Registro Info -->
        <!-- BEGIN: Registro Form -->
        <div
          v-if="!registroListo"
          class="flex flex-col xl:my-10 max-h-[90vh] p-5 w-full overflow-auto"
          :class="{
            'justify-center': !isLoggedIn
          }"
        >
          <div class="flex-col h-auto xl:hidden mt-5">
            <div class="my-auto flex justify-center">
              <img alt="Logo Atiendo" class="w-1/2 -intro-x" />
              <!-- src="/logo_nuevo_blanco_x_color.png" -->
            </div>
            <div
              class="mt-2 text-2xl font-medium leading-tight text-white justify-center"
            >
              <p class="text-center">Atiendo<br /></p>
              <template v-if="ambiente != 'Produccion'">
                <p class="mt-5 text-danger p-3 bg-white">Ambiente DEMO</p>
                <Button
                  variant="primary"
                  class="mb-2 mr-1"
                  @click="irProduccion"
                >
                  Ir a producción
                </Button>
              </template>
            </div>
          </div>
          <div
            class="w-full p-8 mx-auto my-auto bg-white rounded-md shadow-md xl:mx-16 dark:bg-darkmode-600 lg:p-0 lg:shadow-none lg:w-2/4 lg:w-auto"
          >
            <div v-if="isLoggedIn">
              <h2
                class="text-2xl font-bold text-center intro-x xl:text-3xl xl:text-left mb-3"
              >
                Registro
              </h2>
              <template v-if="ambiente != 'Produccion'">
                <h2
                  class="text-2xl font-bold text-center intro-x xl:text-3xl xl:text-left mb-3 text-danger"
                >
                  Ambiente {{ ambiente }}, no será un registro real.
                </h2>
              </template>
              <template v-if="userStore.empresasRegistradas.length == 1">
                <div class="p-2">
                  <Button
                    variant="primary"
                    class="mb-2 mr-1 mt-3"
                    @click="router.push('/login')"
                  >
                    Ya te encuentras registrado/a con la empresa
                    {{ userStore.empresasRegistradas[0].nombreComercial }} -
                    Acceder
                  </Button>
                </div>
              </template>
              <template v-if="userStore.empresasRegistradas.length > 1">
                <div class="p-2">
                  <Button
                    variant="primary"
                    class="mb-2 mr-1 mt-3"
                    @click="router.push('/login')"
                  >
                    Tienes {{ userStore.empresasRegistradas.length }} empresas
                    registradas
                  </Button>
                </div>
              </template>
              <template
                v-if="userStore.user?.email?.endsWith('.fixed.uy') == false"
              >
                <div class="p-2">
                  <p>Te estás registrando como:</p>
                  <p>
                    {{ userStore.usuario?.nombre }}<br />
                    {{ userStore.user?.email }}
                  </p>
                  <Button
                    variant="secondary"
                    size="sm"
                    class="w-32 mb-2 mr-1 mt-3 text-danger"
                    @click="signOutHandler"
                  >
                    Usar otra cuenta
                  </Button>
                </div>
                <FormRegistro @registro-listo="handlerRegistroListo" />
              </template>
              <template v-else>
                <div class="p-2">
                  <p>
                    {{ userStore.usuario?.nombre }}<br />
                    Iniciaste sesión con rut/usuario y clave, y no con una
                    cuenta de mail válida.<br />Debes de usar otra cuenta.
                  </p>
                  <Button
                    variant="primary"
                    class="mb-2 mr-1 mt-3"
                    @click="signOutHandler"
                  >
                    Usar otra cuenta
                  </Button>
                </div>
              </template>
            </div>
            <div v-else>
              <template v-if="ambiente != 'Produccion'">
                <h2
                  class="text-2xl font-bold text-center intro-x xl:text-3xl xl:text-left mb-3 text-danger"
                >
                  Ambiente {{ ambiente }}, no será un registro real.
                </h2>
              </template>
              <SignInFromRegistro />
            </div>
          </div>
        </div>
        <div v-else class="flex-col lg:w-1/2 my-auto mx-20">
          <h2
            class="text-2xl font-bold text-center intro-x xl:text-3xl xl:text-left"
          >
            Registro realizado con éxito!
          </h2>
          <div
            class="my-5 text-left intro-x text-slate-950 dark:text-slate-300"
          >
            <p>
              Te hemos enviado un mail con los datos de tu registro a
              {{ userStore.user?.email }}
            </p>
          </div>
          <router-link to="/">
            <Button variant="primary" class="w-32 mb-2 mr-1">
              Ir al sistema
            </Button>
          </router-link>
        </div>
      </div>
    </div>
    <!-- END: Registro Form -->
  </div>
</template>
